<template>
    <el-dialog
        :title="isForm ? (formId ? '户主-编辑' : '户主-添加') : '户主-详情'"
        :model-value="modelValue"
        top="10vh"
        width="640px"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form
            ref="formRef"
            :model="formData"
            v-loading="loading"
            :rules="isForm ? formRules : {}"
            label-width="150px"
            label-suffix="："
            style="max-width: 560px"
        >
            <el-form-item label="用户姓名" prop="name">
                <el-input v-if="isForm" v-model="formData.name" placeholder="请输入用户姓名" clearable></el-input>
                <span v-else>{{ formData.name }}</span>
            </el-form-item>
            <el-form-item label="联系方式" prop="phone">
                <el-input v-if="isForm" v-model="formData.phone" placeholder="请输入联系方式" clearable></el-input>
                <span v-else>{{ formData.phone }}</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref } from 'vue'
import { addHousehold, putHousehold, getHouseholdDetail } from '@/api/household.js'
import { ElMessage } from 'element-plus'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    formId: {
        type: String,
        required: false
    },
    isForm: {
        type: Boolean,
        default: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    name: '',
    phone: ''
})

// 验证规则

const formRules = ref({
    name: [
        {
            required: true,
            trigger: 'blur',
            message: '请输入用户姓名'
        }
    ],
    phone: [
        {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
                // 联系方式必须为11位纯数字，且为必填项
                if (value === '') {
                    callback(new Error('请输入联系方式'))
                } else if (!/^[0-9]{11}$/.test(value)) {
                    callback(new Error('联系方式必须为11位纯数字'))
                } else {
                    callback()
                }
            }
        }
    ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const closed = () => {
    dialogTitle.value = ''
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
}

// 确定按钮点击事件
const onConfirm = async () => {
    await handleEdit()
}

// 修改
const handleEdit = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const data = { ...formData.value }
        delete data.location
        if (!data.room) {
            delete data.room
        }
        try {
            if (props.formId) {
                data.id = props.formId
                await putHousehold(data)
            } else {
                await addHousehold(data)
            }
            // 修改成功
            emits('updateForm')
            ElMessage.success('添加成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

const loading = ref(false)

onMounted(async () => {
    if (props.formId) {
        loading.value = true
        const obj = await getHouseholdDetail(props.formId)
        formData.value = {
            id: obj.id,
            name: obj.name,
            phone: obj.phone
        }
        loading.value = false
    }
})
</script>

<style scoped></style>
